<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a
        routerLink="/admin/orders/">Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'AO_SELLER'"><a routerLink="/admin/sellerDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'AO_SELLER'"><a routerLink="/admin/sellerOrdersList/">Orders</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">Process Order</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="row align-items-center">
        <div class="col-6">
        </div>
        <div class="col-md-6 mt-4 mt-md-0 text-right float-right">
          <a *ngIf="user.role === 'ROLE_ADMIN'" routerLink="/admin/adminOrder"
             class="text-danger p-2 ml-2"><b>Discard</b></a>
          <a *ngIf="user.role === 'WORK_MEN'" routerLink="/admin/workMenOrder"
             class="text-danger p-2 ml-2"><b>Discard</b></a>
          <button class="btn btn-orange text-white p-2 ml-2" *ngIf="step == 2" (click)="submit()"><b>Back</b></button>
          <button class="btn btn-orange text-white p-2 ml-2"
                  *ngIf="step == 2 && (reviewOrder.orderStatus == 'IN_PROCESS' || reviewOrder.orderStatus == 'SKIP_INVOICE' || reviewOrder.orderStatus == 'PRINT_INVOICE') && reviewOrder.fullFilledBy != 'EASYSHIP'"
                  (click)="submitCreateShipmentForOrder()"><b>Submit</b></button>
          <button class="btn btn-orange text-white p-2 ml-2" *ngIf="step == 2 && reviewOrder.orderStatus == 'CREATED'"
                  (click)="submitUpdatePackingConfiguration()"><b>Submit</b></button>
          <button class="btn btn-orange text-white p-2 ml-2" *ngIf="step == 2 && reviewOrder.fullFilledBy == 'EASYSHIP' && reviewOrder.orderStatus !== 'CREATED'"
                  (click)="submitOrderForEasyShip()"><b>Submit</b></button>
        </div>
      </div>
    </div>
  </div>

  <form *ngIf="step == 1">
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <h5 class="text-black mb-3">Order Details</h5>
          <div class="row">
            <div class="col-lg-4">
              <label><b>Order# : </b>{{reviewOrder.orderNumber}}</label><br>
              <label *ngIf="reviewOrder.sourceOrderId !== null"><b>Source Order# : </b>{{reviewOrder.sourceOrderId}}
              </label><br>
              <label><b>Status : </b>{{reviewOrder.orderStatus | replaceStatus}}</label><br>
              <label><b>Connection Name : </b>{{reviewOrder.connectionName}}</label><br>
              <label><b>Payment Method : </b>{{reviewOrder.paymentMethod}}</label><br>
              <label><b>Weight of Order : </b>{{reviewOrder.weightOfOrder}} {{'kg'}}</label><br>
              <label><b>Amount : </b>{{reviewOrder.totalValue}}</label>
            </div>
            <div class="col-lg-4">
              <label><b>Sender Name : </b>{{reviewOrder.senderName}}</label><br>
              <label><b>Company Name : </b>{{reviewOrder.senderCompanyName}}</label><br>
              <label><b>Sender Address : </b><span class="ml-1">{{reviewOrder.senderAddressText}}</span></label>
              <label><b>Sender Mobile Number : </b>{{reviewOrder.senderMobile}}</label><br>
            </div>
            <div class="col-lg-4">
              <label><b>Receiver Name : </b>{{reviewOrder.receiverName}}</label><br>
              <label><b>Company Name : </b>{{reviewOrder.receiverCompanyName}}</label><br>
              <label><b>Receiver Address : </b>{{reviewOrder.receiverAddressText}}</label>
              <label><b>Receiver Mobile Number : </b>{{reviewOrder.receiverMobile}}</label><br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>


  <form *ngIf="step == 1">
    <div class="col">
      <ul class="list-inline tab-list">
        <li class="list-inline-item ml-2" *ngIf="reviewOrder.orderStatus == 'CREATED'"><a class="list-inline-item"
                                                                                    (click)=" tabChange('packing');"
                                                                                    [ngClass]="{'active': tabClicked === 'packing'}">Packing
        </a></li>
        <li class="list-inline-item ml-3" *ngIf="reviewOrder.orderStatus == 'SKIP_INVOICE'"><a class="nav-link warehouses"
                                                                                         (click)=" tabChange('carrier');"
                                                                                         [ngClass]="{'active': tabClicked === 'carrier'}">Carriers</a>
        </li>
      </ul>
    </div>
    <div *ngIf="tabClicked === 'packing'">
      <div class="row" *ngIf="reviewOrder.orderStatus == 'CREATED'">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black mb-3">Select the Package Type</h2>
            <h6 class="text-black mb-3">How is your inventory configured?</h6>
            <div class="row">
              <div class="col-md-6">
                <div class="form-radio">
                  <input type="radio" name="skuConfig" id="SingleSKU" [(ngModel)]="reviewOrder.productConfig"
                         (change)="change()" [ngModelOptions]="{standalone: true}" value="SKU" required>
                  <label for="SingleSKU">One SKU per box
                    <p class="label-para-size">Each box contains a single SKU</p>
                  </label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-radio">
                  <input type="radio" name="skuConfig" id="multipleSKU" [(ngModel)]="reviewOrder.productConfig"
                         (change)="change()" [ngModelOptions]="{standalone: true}" value="MULTI_SKU" required checked/>
                  <label for="multipleSKU">Multiple SKUs per box
                    <p class="label-para-size">Each box has 2 or more SKUs</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3"
           *ngIf="(reviewOrder.productConfig === 'SKU' || reviewOrder.productConfig === 'MULTI_SKU') && reviewOrder.orderStatus == 'CREATED'">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black mb-3">Packing Configuration</h2>
            <div class="row mt-4">
              <div class="col-md-12" style="overflow-x:auto" *ngIf="reviewOrder.productConfig === 'SKU'">
                <table class="table packing-table packing-table-2" style="line-height:1.5">
                  <thead class="thead-light">
                  <tr>
                    <th>Product <br> SKU</th>
                    <th>Quantity</th>
                    <th>Quantity/Box</th>
                    <th>No.of Boxes</th>
                    <th style="width: 200px">Package Type <br> Box Dimensions (in cm)</th>
                    <th>Weight (in kg)</th>
                    <th>Total Weight (in kg)</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-container *ngFor="let o of reviewOrder.lines">
                    <tr *ngIf="!showAddShipRow(o)">
                      <td class="align-top"
                          [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines?.length)"
                          style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 300px;">
                        {{o.productName}} <br> {{o.sku}}
                      </td>
                      <td class="align-top"
                          [attr.rowspan]="(!o.shipLines?.length ? 1 : o.shipLines?.length)">{{o.quantity}} <img
                        src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced"
                        style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showShipIcon(o)"> <img
                        src="/./assets/images/close.svg" class="float-right" title="Shipment quantity is not mathced"
                        style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                        *ngIf="!showShipIcon(o) &&( o.qtyPerBoxTmp || o.numOfBoxesTmp || o.shipLines.length>1)"></td>
                      <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(o)" class="form-control"
                                                   (change)="populateDimensions(o)" [(ngModel)]="o.qtyPerBoxTmp"
                                                   placeholder="Enter Quantity/Box"
                                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                   [ngModelOptions]="{standalone: true}" required></td>
                      <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(o)" class="form-control"
                                                   (change)="populateDimensions(o);totalWeightCal()"
                                                   placeholder="Enter No.of Boxes"
                                                   [(ngModel)]="o.numOfBoxesTmp"
                                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                   [ngModelOptions]="{standalone: true}" required></td>
                      <td class="bg-color2" style="width: 200px">
                        <ng-select id="package" [(ngModel)]="o.packageType" [disabled]="showAddShipRow(o)"
                                   appendTo="body"
                                   (open)="openPackage()" (change)="populateDimensions(o)"
                                   [ngModelOptions]="{standalone: true}" required
                                   [items]="package"
                                   bindLabel="packingType"
                                   bindValue="packingType"
                                   placeholder="Package Type">
                        </ng-select>
                        <div class="ml-1 mt-2">
                          <input type="text" style="width: 50px !important" [disabled]="o.packageType !== 'Custom'"
                                 [(ngModel)]="o.boxLength"
                                 [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                 placeholder="L"/>

                          <input type="text" style="width: 50px !important" [disabled]="o.packageType !== 'Custom'"
                                 [(ngModel)]="o.boxWidth"
                                 [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                 placeholder="W"/>
                          <input type="text" style="width: 50px !important" [disabled]="o.packageType !== 'Custom'"
                                 [(ngModel)]="o.boxHeight"
                                 [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                 placeholder="H"/>
                        </div>
                      </td>
                      <td class="bg-color2"><input type="text" [(ngModel)]="o.quantityWeight" appOnlyNumbers
                                                   class="form-control" placeholder="Enter Weight(in kg)"
                                                   [ngModelOptions]="{standalone: true}" (change)="totalWeightCal()"
                                                   required>
                      </td>
                      <td>
                        <input disabled [(ngModel)]="o.totalWeight" [ngModelOptions]="{standalone: true}"
                               class="form-control  width-120" required/>
                      </td>
                      <td class="align-middle bg-color2">
                        <a (click)="addShipmentLine(o)" *ngIf="showAddShipmentBtn(o) " data-toggle="tooltip"
                           data-placement="top" title="Add">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.34" height="21.34"
                               viewBox="0 0 21.34 21.34">
                            <path id="Icon_ionic-md-add-circle" data-name="Icon ionic-md-add-circle"
                                  d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                                  transform="translate(-3.375 -3.375)" fill="#ee7125"/>
                          </svg>
                        </a>
                      </td>
                    </tr>
                    <ng-container *ngFor="let s of o?.shipLines; let j=index;">
                      <tr *ngIf="o?.shipLines?.length && j!==0">
                        <td class="align-top" *ngIf="showAddShipRow(o) && j==1"
                            [attr.rowspan]="(!o.shipLines?.length ? 1 : ((o.shipLines?.length && !showAddShipRow(o))? o.shipLines?.length:o.shipLines?.length-1 ))">
                          {{o.productName}}
                        </td>
                        <td class="align-top" *ngIf="showAddShipRow(o) && j==1"
                            [attr.rowspan]="(!o.shipLines?.length ? 1 : ((o.shipLines?.length && !showAddShipRow(o))? o.shipLines?.length:o.shipLines?.length-1 ))">
                          {{o.quantity}}
                          <img src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced"
                               style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showAddShipRow(o)">
                          <img
                            src="/./assets/images/close.svg" class="float-right"
                            title="Shipment quantity is not mathced"
                            style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="!showAddShipRow(o)"></td>
                        <td><input type="text" disabled [(ngModel)]="s.quantityPerBox"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><input type="text" disabled [(ngModel)]="s.numberOfBoxes"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><input type="text" disabled [(ngModel)]="s.packageType" class="form-control w-100"
                                   [ngModelOptions]="{standalone: true}" required>
                          <div class="mt-2 ml-1">
                            <input type="text" style="width: 50px !important" disabled [(ngModel)]="s.boxLength"
                                   appOnlyNumbers
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                   placeholder="L"/>
                            <input type="text" style="width: 50px !important" disabled [(ngModel)]="s.boxWidth"
                                   appOnlyNumbers
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                   placeholder="W"/>
                            <input type="text" style="width: 50px !important" disabled [(ngModel)]="s.boxHeight"
                                   appOnlyNumbers
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline"
                                   placeholder="H"/>
                          </div>
                        </td>

                        <td><input type="text" disabled [(ngModel)]="s.quantityWeight" class="form-control w-120"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><input type="text" disabled [(ngModel)]="s.totalWeight" class="form-control w-120"
                                   [ngModelOptions]="{standalone: true}" required></td>
                        <td><a (click)="removeShipmentLine(o, s)">
                          <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                            <defs>
                              <style>.a {
                                fill: #848484;
                              }



                              </style>
                            </defs>
                            <path class="a"
                                  d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                  transform="translate(-7.5 -4.5)"/>
                          </svg>
                        </a></td>
                      </tr>
                    </ng-container>
                  </ng-container>
                  </tbody>
                </table>
              </div>
              <div class="col-md-12" *ngIf="reviewOrder.productConfig === 'MULTI_SKU'">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group required">
                      <!-- <input type="text" id="numberOfBoxes" [(ngModel)]="numberOfBoxes" (keyup)="changeBox()" class="form-control" [ngModelOptions]="{standalone: true}" required>
                       <label for="numberOfBoxes" class="control-label">Number Of Boxes</label>-->
                      <label class="control-label" for="numberOfBoxes">Number Of Boxes</label>
                      <select class="form-control" id="numberOfBoxes" [(ngModel)]="numberOfBoxesM"
                              [ngModelOptions]="{standalone: true}" (change)="changeBox()"
                              [ngModelOptions]="{standalone: true}" required>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="table-3 table-responsive">
                  <table class="table packing-table packing-table-2">
                    <thead class="thead-light">
                    <tr>
                      <th>Product / SKU</th>
                      <th>Shipment Qty</th>
                      <th *ngFor="let b of reviewOrder.lines[0].shipLines; let i=index;">Box {{i + 1}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colspan="2">Package type</td>
                      <td *ngFor="let b of reviewOrder.lines[0].shipLines">
                        <ng-select id="packagem" class="mt-1" [(ngModel)]="b.packageType" appendTo="body"
                                   (open)="openPackage()"
                                   (click)=selectPackType() (change)="populateDimensions(b)"
                                   [ngModelOptions]="{standalone: true}" required
                                   [items]="package"
                                   bindLabel="packingType"
                                   bindValue="packingType"
                                   placeholder="Package Type" style="width: 220px;">
                        </ng-select>
                        <div class="col-md-12 mt-1">
                          <input type="text" [disabled]="b.packageType !== 'Custom'" appOnlyNumbers
                                 [(ngModel)]="b.boxLength" [ngModelOptions]="{standalone: true}"
                                 class="col-md-3 form-control d-inline" placeholder="L(cm)"/>
                          <input type="text" [disabled]="b.packageType !== 'Custom'" appOnlyNumbers
                                 [(ngModel)]="b.boxWidth" [ngModelOptions]="{standalone: true}"
                                 class="col-md-3 form-control mx-1 d-inline" placeholder="W(cm)"/>
                          <input type="text" [disabled]="b.packageType !== 'Custom'" appOnlyNumbers
                                 [(ngModel)]="b.boxHeight" [ngModelOptions]="{standalone: true}"
                                 class="col-md-3 form-control d-inline" placeholder="H(cm)"/>
                        </div>
                      </td>
                    </tr>
                    <tr *ngFor="let r of reviewOrder.lines">
                      <td>{{r.productName|titlecase}} <br> {{r.sku}}</td>
                      <td>{{r.quantity}} <img src="/./assets/images/tick.svg" class="float-right"
                                              title="Shipment quantity is mathced"
                                              style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                                              *ngIf="showIcon(r)"> <img src="/./assets/images/close.svg"
                                                                        class="float-right"
                                                                        title="Shipment quantity is not mathced"
                                                                        style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                                                                        *ngIf="!showIcon(r) && fieldsEntered(r)"></td>
                      <ng-container *ngFor="let b of r.shipLines">
                        <td *ngIf="b.productId == r.productId">
                          <input type="text" [(ngModel)]="b.quantityPerBox" appOnlyNumbers
                                 [ngModelOptions]="{standalone: true}" class="form-control">
                        </td>
                      </ng-container>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Weight (kg)</td>
                      <td></td>
                      <td *ngFor="let b of reviewOrder.lines[0].shipLines">
                        <input type="text" appOnlyNumbers
                               [(ngModel)]="b.boxWeight" [ngModelOptions]="{standalone: true}"
                               (change)="totalWeightCal()"
                               class="form-control d-inline ml-1 w-68" placeholder="Weight(wt)" style="width: 72px;"/>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col text-right">
          <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
          <button type="submit" *ngIf="reviewOrder.orderStatus == 'IN_PROCESS'" (click)="printInvoice()"
                  class="btn btn-orange ml-2">Print Invoice
          </button>
          <button type="submit" *ngIf="reviewOrder.orderStatus == 'CREATED'" (click)="proceedShipRockForSE()"
                  class="btn btn-orange ml-2">Next
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="tabClicked === 'carrier'">
      <div class="row mt-3">
        <div class="col">
          <div class="inner-box">
            <h2 class="text-black mb-3">Shipping Options</h2>
            <div class="mt-3" *ngIf="reviewOrder.fullFilledBy != 'EASYSHIP'">
              <div class="table-3" style="overflow-x:auto;">
                <table class="table packing-table packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th>Select</th>
                    <th></th>
                    <th>Courier Partner</th>
                    <th>Courier Mode</th>
                    <th>Price</th>
                    <th>Pickup Available</th>
                    <th>Estimated Delivery(in Days)</th>
                  </tr>
                  </thead>
                  <tbody *ngFor="let co of costEstimation; let i=index;">
                  <tr *ngFor="let c of co.costEstimates; let j=index;">
                    <td>
                      <div class="form-radio">
                        <input type="radio" id="cost+{{i}}+{{j}}" (change)="selectCost(c)" required name="costEstimate">
                        <label for="cost+{{i}}+{{j}}"></label>
                      </div>
                    </td>
                    <td><img src="assets/images/1-{{co.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                    <td>
                      {{(co.carrierCode == 'SD' ? 'Shift' :
                      (co.carrierCode == 'DL' ? 'Delhivery' :
                      (co.carrierCode == 'GT' ? 'Gati' :
                      (co.carrierCode == 'WF' ? 'Borzo' :
                      (co.carrierCode == 'DZ' ? 'Dotzot' :
                      (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                      (co.carrierCode == 'SF' ? 'Shadow Fax' :
                      (co.carrierCode == 'XB' ? 'Xpressbees' :
                      (co.carrierCode == 'KE' ? 'Kerry' :
                      (co.carrierCode == 'EX' ? 'EcomXpress Pro' :
                      (co.carrierCode == 'EG' ? 'EcomXpress EGS' :
                      (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode))))))))))))}}
                      <div *ngIf="c.shippingPreference != ''" style="display: inline-flex;"
                           class="ml-2">{{c.shippingPreference}}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="c.deliveryMode && c.serviceType !== null">
                        {{c.deliveryMode + '/' + c.serviceType | replaceStatus}}
                      </div>
                      <div *ngIf="c.serviceType == null">{{c.deliveryMode | replaceStatus}}</div>
                      <div *ngIf="c.deliveryMode == null">{{c.serviceType | replaceStatus}}</div>
                    </td>
                    <td>{{c.totalAmount | currency:'INR'}}</td>
                    <td>{{"Yes"}}</td>
                    <td>{{"1 day"}}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr *ngIf="costEstimation?.length ===0 || !costEstimation?.length">
                    <td [attr.colspan]="7" class="text-center">No Carriers available to serve the Order</td>
                  </tr>
                  </tfoot>
                </table>
                <div class="mt-3 m-3" *ngIf="others == true">
                  <div class="row">
                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label">Carrier Name</label>
                        <input type="text" id="carrierName" class="form-control" [(ngModel)]="carrierName"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="carrierNameBlur()" [ngClass]="{'is-invalid':carrierNameError}">
                        <div [hidden] = "!carrierNameError" class="invalid-feedback d-block shift-invalid-login" id="carrierNameError">
                          {{carrierNameError}}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label" for="shippedDate">Shipped Date</label>
                        <input type="date" id="shippedDate" class="form-control"packageType
                               [(ngModel)]="shippedDate" [ngModelOptions]="{standalone: true}"
                               (blur)="shippedDateBlur()" [ngClass]="{'is-invalid':shippedDateError}">

                        <div [hidden] = "!shippedDateError" class="invalid-feedback d-block shift-invalid-login" id="shippedDateError">
                          {{shippedDateError}}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label">Shipment Cost</label>
                        <input type="text" id="shipmentCost" class="form-control" [(ngModel)]="shipmentCostOther"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="shipmentCostOtherBlur()" [ngClass]="{'is-invalid':shipmentCostOtherError}">
                        <div [hidden] = "!shipmentCostOtherError" class="invalid-feedback d-block shift-invalid-login" id="shipmentCostOtherError">
                          {{shipmentCostOtherError}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="control-label">AWB Number</label>
                        <input type="text" id="AWBNumber" class="form-control" [(ngModel)]="AWBNumber"
                               [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="control-label" for="deliveryPinCode">Tracking URL</label>
                        <input type="text" id="deliveryPinCode" class="form-control"
                               [(ngModel)]="trackingURL" [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="mt-3" *ngIf="reviewOrder.fullFilledBy == 'EASYSHIP'">
              <div class="row">
                <div class="col">
                  <div class="inner-box">
                    <div class="text-center">
                      <h2 class="text-black mb-3 mt-2 review">Slots</h2>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="row">
                          <div class="col">
                            <table class="table">
                              <thead>
                              <tr>
                                <th></th>
                                <th>Start Time</th>
                                <th>End Time</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr *ngFor="let s of slotsList; let i=index;">
                                <td>
                                  <div class="form-radio">
                                    <input type="radio" id="slot+{{i}}" (change)="selectShipList(s)" required
                                           name="slot">
                                    <label for="slot+{{i}}"></label>
                                  </div>
                                </td>
                                <td>{{s.pickupTimeStart | date:'yyyy-MMM-dd hh:mm a':'GMT'}}</td>
                                <td>{{s.pickupTimeEnd | date:'yyyy-MMM-dd hh:mm a':'GMT'}}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
              </div>
              <div class="col-6 text-right">
                <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
                <button type="submit" (click)="reviewAndConfirm()" class="btn btn-orange ml-2">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <form *ngIf="step == 2">
    <div class="row mt-3">
      <div class="col">
        <div id="statusText14" class="invalid-feedback d-block shift-invalid-login"
             [hidden]="!statusText14">{{statusText14}},to add balance click <a>here</a>
        </div>
        <div class="inner-box">
          <div class="text-center">
            <div name="message" id="errorMessage1" class="invalid-feedback d-block shift-invalid-text"
                 [hidden]="!errorMessage1">{{errorMessage1}}
            </div>
            <h2 class="text-black mb-3 mt-2 review">Review and Confirm</h2>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-lg-4">
                  <h2 class="text-black mb-2 review">Order Details</h2>
                  <label><b>Order# :</b><span class="ml-1"></span>{{reviewOrder.orderNumber}}</label><br>
                  <label><b>Create Date :</b><span class="ml-1"></span>{{reviewOrder.orderedDate}}</label><br>
                  <label><b>Status : </b>{{reviewOrder.orderStatus | replaceStatus}}</label><br>
                  <label><b>Connection Name : </b>{{reviewOrder.connectionName}}</label><br>
                  <label><b>Payment Method : </b>{{reviewOrder.paymentMethod}}</label><br>
                  <label *ngIf="reviewOrder.paymentMethod == 'COD'"><b>Amount : </b>{{reviewOrder.totalValue}}</label>
                </div>
                <div class="col-lg-4">
                  <h2 class="text-black mb-2 review">Sender Details</h2>
                  <label><b>Sender Name :</b><span class="ml-1">{{reviewOrder.senderName}}</span></label><br>
                  <label><b>Sender Mobile :</b><span class="ml-1">{{reviewOrder.senderMobile}}</span></label><br>
                  <label><b>Sender Address :</b><span class="ml-1">{{reviewOrder.senderAddressText}}</span></label>
                </div>
                <div class="col-lg-4">
                  <h2 class="text-black mb-2 review">Receiver Details</h2>
                  <label class="text-black"><b>Receiver Name :</b><span
                    class="ml-1">{{reviewOrder.receiverName}}</span></label><br>
                  <label class="text-black"><b>Receiver Mobile :</b><span
                    class="ml-1">{{reviewOrder.receiverMobile}}</span></label><br>
                  <label><b>Receiver Address :</b><span class="ml-1">{{reviewOrder.receiverAddressText}}</span></label>
                </div>
              </div>
              <hr class="row-bordered">
              <h2 class="text-black mb-2 review">Shipping Details</h2>
              <div class="row">
                <div class="col-lg-4">
                  <label><b>No.of Boxes :</b><span class="ml-1">{{totalBoxes}}</span></label><br/>
                </div>
                <div class="col-lg-4">
                  <label><b>Configuration :</b>
                    <label *ngIf="reviewOrder.productConfig == 'SKU'" class="ml-1">One SKU per box</label>
                    <label *ngIf="reviewOrder.productConfig == 'MULTI_SKU'" class="ml-1">Multiple SKUs per box</label>
                  </label><br>
                </div>
                <div class="col-lg-4">
                  <label class="text-black mb-2"><b>Shipment Type :</b>
                    <label class="ml-1">{{(shippingCost.carrierCode == 'SD' ? 'Shift' :
                      (shippingCost.carrierCode == 'DL' ? 'Delhivery' :
                      (shippingCost.carrierCode == 'GT' ? 'Gati' :
                      (shippingCost.carrierCode == 'DZ' ? 'Dotzot' :
                      (shippingCost.carrierCode == 'RD' ? 'Rapid Delivery' :
                      (shippingCost.carrierCode == 'EG' ? 'EcomXpress EGS' :
                      (shippingCost.carrierCode == 'EX' ? 'EcomXpress Pro' :
                      (shippingCost.carrierCode == 'SF' ? 'Shadow Fax' :
                      (shippingCost.carrierCode == 'FE' ? 'FedEx' : shippingCost.carrierCode)))))))))}}</label>
                  </label>

                </div>
              </div>
              <hr class="row-bordered">
              <div class="row">
                <div class="col">
                  <h2 class="text-black mb-2 review">Product Details</h2>
                  <table class="table">
                    <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Quantity Per Box</th>
                      <th>No. of Boxes</th>
                    </tr>
                    </thead>
                    <!--
                                        <tbody>
                                        <ng-container *ngFor="let r of reviewOrder.lines;let j=index;">
                                        <tr>
                                          <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)" style ="text-transform:uppercase;">{{r.sku}}</td>
                                          <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)">{{r.productName|titlecase}}</td>
                                          <td [attr.rowspan]= "(r.shipLines == null ? 1 : r.shipLines.length)">{{r.quantity}}</td>
                                          <td>{{(r.shipLines == null ? 0 : r.shipLines[0].quantityPerBox)}}</td>
                                          <td>{{(r.shipLines == null ? 0 : r.shipLines[0].numberOfBoxes)}}</td>
                                        </tr>
                                      </ng-container>
                                       <ng-container>
                      <ng-container *ngFor="let r of reviewOrder.lines;let j = index;">
                        <tr *ngFor="let d of r.lineProducts; let x=index;">
                          <td *ngIf="x==0" [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)"
                          >{{r.sku}}
                          </td>
                          <td *ngIf="x==0"
                              [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)">
                            {{r.productName|titlecase}}
                          </td>
                          <td *ngIf="x==0"
                              [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)">{{r.quantity}}
                          </td>
                          <td>{{d?.quantityPerBox}}</td>
                          <td
                            *ngIf="(((x==0 && j==1) || (x==0 && j==0)) && reviewOrder.productConfig === 'MULTI_SKU') || reviewOrder.productConfig === 'SKU'"
                            [attr.rowspan]="(reviewOrder.productConfig === 'MULTI_SKU' && reviewOrder.shipLines.length ? reviewOrder.shipLines.length : 1)">
                            {{d?.numberOfBoxes}}
                          </td>
                        </tr>
                        <ng-container *ngFor="let s of r.shipLines;let i= index;">
                          <tr *ngIf="i != 0">
                            <td>{{s.quantityPerBox}}</td>
                            <td>{{s.numberOfBoxes}}</td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                                        </tbody>
                    -->

                    <tbody>
                    <ng-container *ngFor="let r of reviewOrder.lines;let j=index;">
                      <tr>
                        <td [attr.rowspan]="(r.shipLines == null ? 1 : r.shipLines.length)"
                            style="text-transform:uppercase;">{{r.sku}}
                        </td>
                        <td
                          [attr.rowspan]="(r.shipLines == null ? 1 : r.shipLines.length)">{{r.productName|titlecase}}
                        </td>
                        <td [attr.rowspan]="(r.shipLines == null ? 1 : r.shipLines.length)">{{r.quantity}}</td>
                        <td>{{(r.shipLines == null ? 0 : r.shipLines[0].quantityPerBox)}}</td>
                        <td>{{(r.shipLines == null ? 0 : r.shipLines[0].numberOfBoxes)}}</td>
                      </tr>
                      <ng-container *ngFor="let s of r.shipLines;let i= index;">
                        <tr *ngIf="i != 0">
                          <td>{{s.quantityPerBox}}</td>
                          <td>{{s.numberOfBoxes}}</td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    <ng-container>
                      <ng-container *ngFor="let r of reviewOrder.lines;let j = index;">
                        <tr *ngFor="let d of r.lineProducts; let x=index;">
                          <td *ngIf="x==0" [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)"
                          >{{r.sku}}
                          </td>
                          <td *ngIf="x==0"
                              [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)">
                            {{r.productName|titlecase}}
                          </td>
                          <td *ngIf="x==0"
                              [attr.rowspan]="(!r.lineProducts.length ? 1 : r.lineProducts.length)">{{r.quantity}}
                          </td>
                          <td>{{d?.quantityPerBox}}</td>
                          <td
                            *ngIf="(((x==0 && j==1) || (x==0 && j==0)) && reviewOrder.productConfig === 'MULTI_SKU') || reviewOrder.productConfig === 'SKU'"
                            [attr.rowspan]="(reviewOrder.productConfig === 'MULTI_SKU' && reviewOrder.shipLines.length ? reviewOrder.shipLines.length : 1)">
                            {{d?.numberOfBoxes}}
                          </td>
                        </tr>
                        <ng-container *ngFor="let s of r.shipLines;let i= index;">
                          <tr *ngIf="i != 0">
                            <td>{{s.quantityPerBox}}</td>
                            <td>{{s.numberOfBoxes}}</td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

</section>


<div [ngStyle]="{'display': printInvoicePopUp =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': printInvoicePopUp == 'Y'}" class="modal" id="printInvoicePopUp" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Skip Invoice</h5>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col">
              <div class="form-group required">
                <div id="statusText13" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText13">{{statusText13}}
                </div>
                <label class="control-label">We are unable to fetch invoice from channel.
                  Do you want skip invoice and proceed, If Yes please provide reason.</label>
                <textarea id="reason" [(ngModel)]="invoiceReason" rows="4" maxlength="250" (blur)="enterInvoiceReason()"
                          class="form-control" [ngModelOptions]="{standalone: true}" required></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col mt-2 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="SkipInvoice()">Skip</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': creditBalancePopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': creditBalancePopup == 'Y'}" class="modal" id="creditBal" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document" style="max-width:900px">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h2 class="modal-title">Add Credits
        </h2>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 mt-2 mb-2 required">
            <div class="row d-flex justify-content-around my-3">
              <div class="col-md-6">
                <div class="row d-flex justify-content-around">
                  <div class="col form-group">
                    <label class="control-label">Amount</label>
                    <input type="text" id="amount" class="form-control" (blur)="typeAmount()"
                           [ngClass]="{'is-invalid':amountError}" [(ngModel)]="amount"
                           [ngModelOptions]="{standalone: true}" appOnlyNumbers required>
                    <div id="amountError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!amountError">
                      {{amountError}}
                    </div>
                  </div>
                  <div class="col-md-6 ms-1">
                    <button id="Button" class="btn btn-orange" (click)="submitCreditBal()" style="margin-top: 23px;">Pay Now</button>
                  </div>
                </div>
              </div>
              <div class=" col-md-6 " style="text-align: right">
                <img referrerpolicy="origin"
                     src="https://badges.razorpay.com/badge-dark.png "
                     style="height: 67px;width: 165px;"
                     alt="Razorpay | Payment Gateway | Neobank">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
